import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idcommissione2roman',
  standalone: false
})
export class IdCommissioneToRomanPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    // This should come from DB
    const commissions = {
      '60016e07671c8e40363ec029': 'I',
      '60016e08671c8e40363ec02a': 'II',
      '60016e08671c8e40363ec02b': 'III',
      '60016e08671c8e40363ec02c': 'IV',
      '60016e08671c8e40363ec02d': 'V',
      '60016e08671c8e40363ec02e': 'VI',
      '60016e08671c8e40363ec02f': 'VII',
      '60016e08671c8e40363ec030': 'VIII',
      '60016e08671c8e40363ec031': 'IX',
      '60016e08671c8e40363ec032': 'X',
      '60016e08671c8e40363ec033': 'XI',
      '60016e08671c8e40363ec034': 'XII',
      '60016e08671c8e40363ec035': 'XIII',
      '60016e09671c8e40363ec036': 'XIV',
      '60016e09671c8e40363ec037': 'I',
      '60016e09671c8e40363ec038': 'II',
      '60016e09671c8e40363ec039': 'III',
      '60016e09671c8e40363ec03a': 'IV',
      '60016e09671c8e40363ec03b': 'V',
      '60016e09671c8e40363ec03c': 'VI',
      '60016e09671c8e40363ec03d': 'VII',
      '60016e09671c8e40363ec03e': 'VIII',
      '60016e09671c8e40363ec03f': 'IX',
      '60016e09671c8e40363ec040': 'X',
      '60016e09671c8e40363ec041': 'XI',
      '60016e09671c8e40363ec042': 'XII',
      '60016e09671c8e40363ec043': 'XIII',
      '60016e09671c8e40363ec044': 'XIV',
    };
    if (value.includes(',')) { // Multiple commissions
      const splittedCommissions = value.split(',');
      const array = [];
      for (const split of splittedCommissions) {
        array.push(commissions[split]);
      }
      return array.join(', ');
    }
    return commissions[value] || '';
  }

}
